<template>
  <div class="home">
    <NavBar />
    <!-- <div class="Emodal z-50" >
      <div
        class="Emodal-content z-50 rounded-md relative bottom-24 md:w-[35%] 2xl:w-[20%]"
      >
        <span class="close z-50" @click="closeModal">&times;</span>
        <popupView ref="popup" />
      </div>
    </div> -->
    <section>
      <BannerView />
    </section>
    <section>
      <DegreeProgram />
    </section>
    <section>
      <RankingHomeView />
    </section>
<SkillsHome />
    <RedefineView />
    <FacultyView />
    <VideoHome />
    <NewsView />
    <!-- <section class="pb-8">
      <h2 class="uppercase text-lg md:text-2xl font-bold pt-8">
        HIRING <span class="text-primary">COMPANIES</span>
      </h2>
      <HiringComp />
    </section> -->
    <section>
      <FaQ />
    </section>
    <section>
      <FooterView />
    </section>
    <StickyView />
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import BannerView from "@/components/HomeBanner.vue";
import NavBar from "@/components/NavBar.vue";
//import popupView from "@/components/popupView.vue"
import StickyView  from "@/components/StickyView.vue";
const NewsView = defineAsyncComponent(() =>
  import(/* webpackChunkName: "newsandmedia" */ "@/components/NewsView.vue")
);
const RankingHomeView = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "rankingHome" */ "@/components/RankingHomeView.vue"
  )
);
const DegreeProgram = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "degreeprograms" */ "@/components/DegreeProgram.vue"
  )
);
const FaQ = defineAsyncComponent(() =>
  import(/* webpackChunkName: "ranking" */ "@/components/FaQ.vue")
);
// const HiringComp = defineAsyncComponent(() =>
//   import(/* webpackChunkName: "ranking" */ "@/components/HiringComp.vue")
// );
const FooterView = defineAsyncComponent(() =>
  import(/* webpackChunkName: "ranking" */ "@/components/FooterView.vue")
);
const SkillsHome = defineAsyncComponent(() =>
  import(/* webpackChunkName: "skillshome" */ "@/components/SkillsHome.vue")
);
const RedefineView = defineAsyncComponent(() =>
  import(/* webpackChunkName: "skillshome" */ "@/components/RedefineView.vue")
);
const FacultyView = defineAsyncComponent(() =>
  import(/* webpackChunkName: "skillshome" */ "@/components/FacultyView.vue")
);
const VideoHome = defineAsyncComponent(() =>
  import(/* webpackChunkName: "skillshome" */ "@/components/VideoHome.vue")
);
export default {
  name: "HomeView",
  components: {
    BannerView,
    DegreeProgram,
    // HiringComp,
    FooterView,
    RankingHomeView,
    NewsView,
    FaQ,
    StickyView,
    NavBar,
    SkillsHome,
    RedefineView,
    FacultyView,
    VideoHome,
  //  popupView,
  },
  // mounted() {
  // setTimeout(() => {
  //     this.$refs.popup.openPopup();
  //   }, 1000); 
  // },
};
</script>

<style scoped>
/* your modal and overlay styles here */
.modal {
  display: none;
  position: fixed;
  z-index: 1;
  padding-top: 150px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.3);
}

/* Modal Content */
.modal-content1 {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 50%;
}

@media (max-width: 767.98px) {
  .modal-content1 {
    background-color: #fefefe;
    margin: auto;
    padding: 20px;
    border: 1px solid #888;
    width: 100%;
  }
}

/* The Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
.accordion-content {
  transition: max-height 0.3s ease-out;
}
</style>
